import { render, staticRenderFns } from "./CoreSelectCourse.vue?vue&type=template&id=e991eac2"
import script from "./CoreSelectCourse.vue?vue&type=script&lang=js"
export * from "./CoreSelectCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports